import { Tooltip, Table, Tag, Popconfirm, Button, Modal, Form, Row, Col, Input, message } from "antd";
import styles from "./index.module.scss"
import { dealFileSize } from "@/utils/dealFileSize";
import { DeleteOutlined, SecurityScanOutlined } from '@ant-design/icons';
import { useState } from "react"
import { gridDetail, updateGridResult } from "@/apis/discover";
import intl from "react-intl-universal";

const raster = {
	imageUuid: "",
	fileUuid: ""
}

const ShareFileList = ({ files, upList, type, resourceType, secondType }) => {
	const msg = "please fill in."
	const [isOpen, setIsOpen] = useState(false)
	const [obj, setObj] = useState({})

	const columns = [
		{
			title: intl.get('Share.File Name'),
			key: 'fileName',
			dataIndex: 'fileName',
			width: 500,
		},
		{
			title: intl.get('Share.File Type'),
			key: 'fileType',
			dataIndex: 'fileFormat',
			width: 90,
			render: (text, record, index) => (
				<Tag color="gold">{text}</Tag>
			),
		},
		{
			title: intl.get('Share.File Size'),
			key: 'fileSize',
			dataIndex: 'fileSize',
			width: 90,
			render: (text, record, index) => (
				<span>{dealFileSize(text)}</span>
			),
		},
		{
			title: intl.get('Operation'),
			key: 'operate',
			width: 100,
			render: (text, record) => (
				<div className={styles.downBox}>
					<Tooltip title={intl.get("Delete the file")}>
						<Popconfirm
							title={intl.get("Delete the file")}
							description={intl.get("Whether to continue the execution")}
							onConfirm={(e) => deleteFile(e, record.fileUuid)}
							okText={intl.get("Yes")}
							cancelText={intl.get("No")}
						>
							<DeleteOutlined style={{ color: "#d62293", fontSize: "18px" }} />
						</Popconfirm>
					</Tooltip>

					{type === "content" && resourceType === "Raster" && secondType === "OpenGeospatialData" && <Tooltip title={intl.get("Share.View meta data")}>
						<SecurityScanOutlined onClick={() => seeMetaData(record.fileUuid,)} style={{ color: "#1677ff", fontSize: "18px" }} />
					</Tooltip>}
				</div>
			),
		},
	];
	// 删除文件操作
	const deleteFile = (e, fileUuid) => {
		const arr = files.filter(item => item.fileUuid !== fileUuid)
		upList(arr)
	}

	// 查看raster文件解析结果
	const seeMetaData = (fileUuid) => {
		gridDetail({
			fileUuid: fileUuid
		}).then(res => {
			const result = res.data || {}
			setObj({
				imageWidth: result.imageWidth,
				imageLength: result.imageLength,
				bitsPerSample: result.bitsPerSample,
				compression: result.compression,
				samplesPerPixel: result.samplesPerPixel,
				tileWidth: result.tileWidth,
				tileLength: result.tileLength,
				tileOffsets: JSON.stringify(result.tileOffsets),
				tileByteCounts: JSON.stringify(result.tileByteCounts),
				sampleFormat: result.sampleFormat,
				spatialReference: result.spatialReference,
				gdalMetadata: result.gdalNodata,
				cellScale: JSON.stringify(result.cellScale),
				geoTransform: JSON.stringify(result.geoTransform),
				gdalNodata: result.gdalNodata,
			})
			setIsOpen(true)
			raster.imageUuid = result.imageUuid
			raster.fileUuid = fileUuid
		}).catch(err => { })
	}

	// 编辑
	const onFinish = (values) => {
		updateGridResult({
			...raster,
			imageWidth: values.imageWidth,
			imageLength: values.imageLength,
			bitsPerSample: values.bitsPerSample,
			compression: values.compression,
			samplesPerPixel: values.samplesPerPixel,
			tileWidth: values.tileWidth,
			tileLength: values.tileLength,
			tileOffsets: JSON.parse(values.tileOffsets),
			tileByteCounts: JSON.parse(values.tileByteCounts),
			sampleFormat: values.sampleFormat,
			spatialReference: values.spatialReference,
			gdalMetadata: values.gdalNodata,
			cellScale: JSON.parse(values.cellScale),
			geoTransform: JSON.parse(values.geoTransform),
			gdalNodata: values.gdalNodata,
		}).then(res => {
			message.success(intl.get("Update successfully"));
			setIsOpen(false)
		}).catch(err => { })
	}

	return (
		<div>
			<Table
				style={{ marginTop: "20px" }}
				rowKey={record => record.fileUuid}
				size="small"
				scroll={{ y: "350px" }}
				pagination={false}
				dataSource={files}
				columns={columns} />

			<Modal
				title={intl.get("Meta.Meta Data")}
				width={1200}
				open={isOpen}
				footer={null}
				onCancel={() => {
					setIsOpen(false)
				}}>
				<Form
					onFinish={onFinish}
					autoComplete="off"
					layout="vertical"
					initialValues={obj}
					className={styles.formBox}
				>
					<Row gutter={40}>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Image width")}
								name="imageWidth"
								rules={[
									{
										required: true,
										message: msg,
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Image length")}
								name="imageLength"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.BitsPer sample")}
								name="bitsPerSample"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Compression")}
								name="compression"
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Samples perPixel")}
								name="samplesPerPixel"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Tile width")}
								name="tileWidth"
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Tile length")}
								name="tileLength"
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Tile offsets")}
								name="tileOffsets"
							>
								<Input placeholder="example:[0,0,0]" />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Tile byte counts")}
								name="tileByteCounts"
							>
								<Input placeholder="example:[0,0,0]" />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Sample format")}
								name="sampleFormat"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.Spatial reference")}
								name="spatialReference"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.GDAL_Metadata")}
								name="gdalMetadata"
							>
								<Input />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								label={intl.get("Meta.Cell scale")}
								name="cellScale"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input placeholder="example:[[0,0],[0,0]]" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								label={intl.get("Meta.Geo transForm")}
								name="geoTransform"
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<Input placeholder="example:[[0,0,0],[0,0,0],[0,0,0]]" />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								label={intl.get("Meta.GDAL_Nodata")}
								name="gdalNodata"
							>
								<Input />
							</Form.Item>
						</Col>
					</Row>
					<Form.Item>
						<Button type="primary" htmlType="submit">
							{intl.get("Share.Submit")}
						</Button>
					</Form.Item>
				</Form>
			</Modal>

		</div>
	)
}
export default ShareFileList;